import Paper from '@mui/material/Paper';
import { useRef } from 'react';
import Draggable from 'react-draggable';

const DraggableDialog: React.FC = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
};
export default DraggableDialog;
